import { useLayoutEffect, useRef } from "react";
import Experience from "../../Experience/Experience";
import "./FrontendExperience.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function FrontendExperience() {
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".fe-head .eyebrow", {
        y: 20, opacity: 0, duration: 0.6, ease: "power3.out",
        scrollTrigger: { trigger: ".fe-head", start: "top 88%" },
      });
      gsap.from(".fe-head h2", {
        y: 40, opacity: 0, duration: 0.8, ease: "power3.out",
        scrollTrigger: { trigger: ".fe-head", start: "top 85%" },
      });
      gsap.from(".fe-head p", {
        y: 20, opacity: 0, duration: 0.6, delay: 0.1, ease: "power3.out",
        scrollTrigger: { trigger: ".fe-head", start: "top 85%" },
      });
      gsap.from(".fe-grid .experience-card", {
        y: 40, opacity: 0, duration: 0.7, stagger: 0.12, ease: "power3.out",
        scrollTrigger: { trigger: ".fe-grid", start: "top 88%" },
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="skills-section frontend-section">
      <div className="skills-inner">
        <div className="fe-head skills-head">
          <span className="eyebrow">01 — Frontend</span>
          <h2>
            Frontend <span className="grad-text">Development</span>
          </h2>
          <p>Crafting fast, pixel-perfect interfaces with modern tooling and motion.</p>
        </div>
        <div className="fe-grid skills-grid">
          <Experience name="HTML" level="Advanced" image="html-icon.png" />
          <Experience name="CSS" level="Advanced" image="css-icon.png" />
          <Experience name="React" level="Advanced" image="react-icon.png" />
        </div>
      </div>
    </section>
  );
}
